import { createContext, type ReactNode, useContext } from "react";
type NativeDropdownPresentation = "sheet" | "popover";
type DropdownSurfaceValue = {
  nativePresentation: NativeDropdownPresentation;
  nativeAnchorHeight?: number;
};
const DropdownSurfaceContext = createContext<DropdownSurfaceValue>({
  nativePresentation: "sheet"
});
export const DropdownSurfaceProvider = ({
  children,
  nativePresentation,
  nativeAnchorHeight
}: DropdownSurfaceValue & {
  children: ReactNode;
}) => <DropdownSurfaceContext.Provider value={{
  nativePresentation,
  nativeAnchorHeight
}} data-sentry-element="DropdownSurfaceContext.Provider" data-sentry-component="DropdownSurfaceProvider" data-sentry-source-file="DropdownSurfaceContext.tsx">
    {children}
  </DropdownSurfaceContext.Provider>;
export const useDropdownSurface = () => useContext(DropdownSurfaceContext);